import {useNavigate} from "react-router-dom";
import LogoPlaceholder from '../../../../components/LogoPlaceHolder';

const Header = (props) => {
    const {promoter} = props;

    return (
        <header className="header">
            <div className="menu-bar-pc">
                <a href="/home">
                    {promoter.logoURL && !promoter.logoURL.includes('null') ? <img src={promoter.logoURL} alt={promoter.fullname} className="logo" /> : <LogoPlaceholder name={promoter.fullname} />}
                </a>
            </div>

            <div className={"menu-bar-movil"}>
                <div className={'menu-bar-movil__wrapper'}>
                    <a href="/home">
                        {promoter.logoURL && !promoter.logoURL.includes('null') ? <img src={promoter.logoURL} alt={promoter.fullname} className="logo" /> : <LogoPlaceholder name={promoter.fullname} />}
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;
